var cov_24lrp3xbvt = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Year.tsx",
      hash = "19cfb02b76d339b15384f0c0567b5c0b36f6348c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Year.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 18
        },
        end: {
          line: 11,
          column: 39
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 16
        }
      },
      "2": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 65
        }
      },
      "3": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 64
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 48
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 56
        }
      },
      "6": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 68
        }
      },
      "7": {
        start: {
          line: 30,
          column: 25
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "8": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 63
        }
      },
      "9": {
        start: {
          line: 35,
          column: 54
        },
        end: {
          line: 35,
          column: 64
        }
      },
      "10": {
        start: {
          line: 36,
          column: 17
        },
        end: {
          line: 36,
          column: 75
        }
      },
      "11": {
        start: {
          line: 37,
          column: 23
        },
        end: {
          line: 37,
          column: 49
        }
      },
      "12": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 80
        }
      },
      "13": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "14": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "15": {
        start: {
          line: 40,
          column: 25
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "16": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "17": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 21
        }
      },
      "18": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 26
        }
      },
      "19": {
        start: {
          line: 48,
          column: 34
        },
        end: {
          line: 48,
          column: 44
        }
      },
      "20": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 100
        }
      },
      "21": {
        start: {
          line: 53,
          column: 66
        },
        end: {
          line: 53,
          column: 76
        }
      },
      "22": {
        start: {
          line: 54,
          column: 21
        },
        end: {
          line: 54,
          column: 83
        }
      },
      "23": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "24": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 81
        }
      },
      "25": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "26": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 33
        }
      },
      "27": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "28": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 69,
          column: 7
        }
      },
      "29": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 25
        }
      },
      "30": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 21
        }
      },
      "31": {
        start: {
          line: 75,
          column: 22
        },
        end: {
          line: 75,
          column: 32
        }
      },
      "32": {
        start: {
          line: 76,
          column: 17
        },
        end: {
          line: 76,
          column: 107
        }
      },
      "33": {
        start: {
          line: 77,
          column: 23
        },
        end: {
          line: 77,
          column: 48
        }
      },
      "34": {
        start: {
          line: 79,
          column: 22
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "35": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      "36": {
        start: {
          line: 92,
          column: 24
        },
        end: {
          line: 92,
          column: 34
        }
      },
      "37": {
        start: {
          line: 93,
          column: 15
        },
        end: {
          line: 93,
          column: 72
        }
      },
      "38": {
        start: {
          line: 94,
          column: 18
        },
        end: {
          line: 94,
          column: 50
        }
      },
      "39": {
        start: {
          line: 94,
          column: 43
        },
        end: {
          line: 94,
          column: 49
        }
      },
      "40": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 39
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 15
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 29
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 47
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 24
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 11
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 91
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 94,
            column: 38
          },
          end: {
            line: 94,
            column: 39
          }
        },
        loc: {
          start: {
            line: 94,
            column: 43
          },
          end: {
            line: 94,
            column: 49
          }
        },
        line: 94
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 26
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 26
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 24
          }
        }, {
          start: {
            line: 54,
            column: 28
          },
          end: {
            line: 54,
            column: 83
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 55
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 19
          },
          end: {
            line: 56,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 19
          },
          end: {
            line: 56,
            column: 22
          }
        }, {
          start: {
            line: 56,
            column: 26
          },
          end: {
            line: 56,
            column: 81
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }],
        line: 59
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 19
          }
        }, {
          start: {
            line: 59,
            column: 23
          },
          end: {
            line: 59,
            column: 38
          }
        }, {
          start: {
            line: 59,
            column: 42
          },
          end: {
            line: 59,
            column: 72
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 63
      },
      "8": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 19
          }
        }, {
          start: {
            line: 63,
            column: 23
          },
          end: {
            line: 63,
            column: 34
          }
        }, {
          start: {
            line: 63,
            column: 38
          },
          end: {
            line: 63,
            column: 56
          }
        }],
        line: 63
      },
      "9": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        }, {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        }],
        line: 64
      },
      "10": {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 66,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 20
          }
        }, {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 102
          }
        }],
        line: 65
      },
      "11": {
        loc: {
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 6
          },
          end: {
            line: 80,
            column: 11
          }
        }, {
          start: {
            line: 80,
            column: 15
          },
          end: {
            line: 80,
            column: 72
          }
        }, {
          start: {
            line: 80,
            column: 76
          },
          end: {
            line: 80,
            column: 84
          }
        }],
        line: 80
      },
      "12": {
        loc: {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 81,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 81,
            column: 16
          }
        }, {
          start: {
            line: 81,
            column: 20
          },
          end: {
            line: 81,
            column: 30
          }
        }],
        line: 81
      },
      "13": {
        loc: {
          start: {
            line: 85,
            column: 51
          },
          end: {
            line: 85,
            column: 107
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 64
          },
          end: {
            line: 85,
            column: 73
          }
        }, {
          start: {
            line: 85,
            column: 76
          },
          end: {
            line: 85,
            column: 107
          }
        }],
        line: 85
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Year.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { range as getRange } from '../utils/numbers';
import { datepickerClass } from './styles';
import Icon from './Icon';
import { getLocale } from '../locale';
import utils from './utils';
import paramUtils from './paramUtils';
import { isArray } from '../utils/is';
var MONTHBASE = (cov_24lrp3xbvt.s[0]++, '2019-01-01 00:00:00');

var Year =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Year, _PureComponent);

  var _super = _createSuper2(Year);

  function Year(props) {
    var _this;

    _classCallCheck(this, Year);

    cov_24lrp3xbvt.f[0]++;
    cov_24lrp3xbvt.s[1]++;
    _this = _super.call(this, props);
    _this.handlePrevRange = void 0;
    _this.handleNextRange = void 0;
    cov_24lrp3xbvt.s[2]++;
    _this.handlePrevRange = _this.handleRangeChange.bind(_assertThisInitialized(_this), -15);
    cov_24lrp3xbvt.s[3]++;
    _this.handleNextRange = _this.handleRangeChange.bind(_assertThisInitialized(_this), 15);
    cov_24lrp3xbvt.s[4]++;
    _this.renderYear = _this.renderYear.bind(_assertThisInitialized(_this));
    cov_24lrp3xbvt.s[5]++;
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    cov_24lrp3xbvt.s[6]++;
    props.disabledRegister(_this.handleDisabled, 'year', props.index);
    return _this;
  }

  _createClass(Year, [{
    key: "getOptions",
    value: function getOptions() {
      cov_24lrp3xbvt.f[1]++;

      var _ref = (cov_24lrp3xbvt.s[7]++, this.props),
          timeZone = _ref.timeZone;

      cov_24lrp3xbvt.s[8]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(year) {
      cov_24lrp3xbvt.f[2]++;

      var _ref2 = (cov_24lrp3xbvt.s[9]++, this.props),
          current = _ref2.current,
          onChange = _ref2.onChange,
          onModeChange = _ref2.onModeChange,
          type = _ref2.type;

      var date = (cov_24lrp3xbvt.s[10]++, utils.changeDate(current, 'year', year, this.getOptions()));
      var isYearType = (cov_24lrp3xbvt.s[11]++, this.props.type === 'year');
      cov_24lrp3xbvt.s[12]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(date, isYearType, isYearType)));
      cov_24lrp3xbvt.s[13]++;

      if (isYearType) {
        cov_24lrp3xbvt.b[0][0]++;
        cov_24lrp3xbvt.s[14]++;
        return;
      } else {
        cov_24lrp3xbvt.b[0][1]++;
      }

      var nextMode = (cov_24lrp3xbvt.s[15]++, 'month');
      cov_24lrp3xbvt.s[16]++;

      if (type === 'quarter') {
        cov_24lrp3xbvt.b[1][0]++;
        cov_24lrp3xbvt.s[17]++;
        nextMode = type;
      } else {
        cov_24lrp3xbvt.b[1][1]++;
      }

      cov_24lrp3xbvt.s[18]++;
      onModeChange(nextMode);
    }
  }, {
    key: "handleRangeChange",
    value: function handleRangeChange(year) {
      cov_24lrp3xbvt.f[3]++;

      var _ref3 = (cov_24lrp3xbvt.s[19]++, this.props),
          current = _ref3.current,
          onChange = _ref3.onChange;

      cov_24lrp3xbvt.s[20]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(utils.addYears(current, year, this.getOptions()))));
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(date) {
      cov_24lrp3xbvt.f[4]++;

      var _ref4 = (cov_24lrp3xbvt.s[21]++, this.props),
          min = _ref4.min,
          disabled = _ref4.disabled,
          range = _ref4.range,
          type = _ref4.type,
          index = _ref4.index,
          rangeDate = _ref4.rangeDate,
          max = _ref4.max;

      var isDisabled = (cov_24lrp3xbvt.s[22]++, (cov_24lrp3xbvt.b[2][0]++, min) && (cov_24lrp3xbvt.b[2][1]++, utils.compareYear(min, date, 1, this.getOptions()) >= 0));
      cov_24lrp3xbvt.s[23]++;

      if (!isDisabled) {
        cov_24lrp3xbvt.b[3][0]++;
        cov_24lrp3xbvt.s[24]++;
        isDisabled = (cov_24lrp3xbvt.b[4][0]++, max) && (cov_24lrp3xbvt.b[4][1]++, utils.compareYear(date, max, 1, this.getOptions()) >= 0);
      } else {
        cov_24lrp3xbvt.b[3][1]++;
      }

      cov_24lrp3xbvt.s[25]++;

      if ((cov_24lrp3xbvt.b[6][0]++, !isDisabled) && (cov_24lrp3xbvt.b[6][1]++, type === 'year') && (cov_24lrp3xbvt.b[6][2]++, typeof disabled === 'function')) {
        cov_24lrp3xbvt.b[5][0]++;
        cov_24lrp3xbvt.s[26]++;
        isDisabled = disabled(date);
      } else {
        cov_24lrp3xbvt.b[5][1]++;
      }

      cov_24lrp3xbvt.s[27]++;

      if ((cov_24lrp3xbvt.b[8][0]++, !isDisabled) && (cov_24lrp3xbvt.b[8][1]++, index === 1) && (cov_24lrp3xbvt.b[8][2]++, isArray(rangeDate))) {
        cov_24lrp3xbvt.b[7][0]++;
        cov_24lrp3xbvt.s[28]++;

        if ((cov_24lrp3xbvt.b[10][0]++, rangeDate[0]) && (cov_24lrp3xbvt.b[10][1]++, utils.compareAsc(date, utils.addSeconds(rangeDate[0], range, this.getOptions())) > 0)) {
          cov_24lrp3xbvt.b[9][0]++;
          cov_24lrp3xbvt.s[29]++;
          isDisabled = true;
        } else {
          cov_24lrp3xbvt.b[9][1]++;
        }
      } else {
        cov_24lrp3xbvt.b[7][1]++;
      }

      cov_24lrp3xbvt.s[30]++;
      return isDisabled;
    }
  }, {
    key: "renderYear",
    value: function renderYear(y) {
      cov_24lrp3xbvt.f[5]++;

      var _ref5 = (cov_24lrp3xbvt.s[31]++, this.props),
          value = _ref5.value;

      var date = (cov_24lrp3xbvt.s[32]++, utils.changeDate(utils.toDate(MONTHBASE, this.getOptions()), 'year', y, this.getOptions()));
      var isDisabled = (cov_24lrp3xbvt.s[33]++, this.handleDisabled(date));
      var className = (cov_24lrp3xbvt.s[34]++, datepickerClass((cov_24lrp3xbvt.b[11][0]++, value) && (cov_24lrp3xbvt.b[11][1]++, utils.getDateInfo(value, 'year', this.getOptions()) === y) && (cov_24lrp3xbvt.b[11][2]++, 'active'), (cov_24lrp3xbvt.b[12][0]++, isDisabled) && (cov_24lrp3xbvt.b[12][1]++, 'disabled')));
      cov_24lrp3xbvt.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: y,
          className: className,
          onClick: isDisabled ? (cov_24lrp3xbvt.b[13][0]++, undefined) : (cov_24lrp3xbvt.b[13][1]++, this.handleChange.bind(this, y)),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 85,
            columnNumber: 7
          }
        }, y)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_24lrp3xbvt.f[6]++;

      var _ref6 = (cov_24lrp3xbvt.s[36]++, this.props),
          current = _ref6.current;

      var cy = (cov_24lrp3xbvt.s[37]++, utils.getDateInfo(current, 'year', this.getOptions()) - 7);
      var years = (cov_24lrp3xbvt.s[38]++, getRange(15, 0).map(function (i) {
        cov_24lrp3xbvt.f[7]++;
        cov_24lrp3xbvt.s[39]++;
        return cy + i;
      }));
      cov_24lrp3xbvt.s[40]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('year-picker'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 97,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('header'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleLeft",
          className: "left",
          onClick: this.handlePrevRange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 99,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: datepickerClass('ym'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 101,
            columnNumber: 11
          }
        }, "".concat(years[0], " ~ ").concat(years[years.length - 1])),
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleRight",
          className: "right",
          onClick: this.handleNextRange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 11
          }
        })),
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('list'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 106,
            columnNumber: 9
          }
        }, years.map(this.renderYear)))
      );
    }
  }]);

  return Year;
}(PureComponent);

export default Year;